var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-3"},[_c('i',{class:_vm.iconClass}),_c('h6',{staticClass:"font-w300 metric-title text-nowrap"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.$slots.content)?_c('div',[_vm._t("content")],2):_c('div',[_c('h3',{staticClass:"font-w300 metric-content mb-0"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }